import {Component, OnInit} from '@angular/core';
import {RequesterService} from '../../../services/requester.service';
import {AuthService} from '../../../services/auth.service';
import {AlertController, LoadingController, NavController, Platform} from '@ionic/angular';
import {ProgressService} from '../../../services/progress.service';
import {environment} from '../../../../environments/environment';
import {
  fadeInLeftOnEnterAnimation,
  fadeInOnEnterAnimation,
  fadeInRightOnEnterAnimation, fadeOutOnLeaveAnimation, fadeOutRightOnLeaveAnimation,
  headShakeAnimation,
} from 'angular-animations';
import {EventsService} from '../../../services/events.service';
import {NavService} from '../../../services/nav.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AnalyticsService} from '../../../services/analytics.service';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../../services/user.service';
import {MsalBroadcastService, MsalService} from '@azure/msal-angular';
import {InteractionStatus} from '@azure/msal-browser';
import {filter} from 'rxjs/operators';
// import { Msal } from 'ionic-msal-native';
import jwt_decode from 'jwt-decode';
import { AuthService as OktaAuthService} from '@auth0/auth0-angular';
import {ActivatedRoute} from '@angular/router';

class LoginForm {
  login: string = null;
  password: string = null;
  blockManagerLogin = false;
}

@Component({
  selector: 'app-login-legacy',
  templateUrl: './login-legacy.page.html',
  styleUrls: ['./login-legacy.page.scss'],
  animations: [
    fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
    fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
    fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
    fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
    fadeInRightOnEnterAnimation({anchor: 'enterListRight', duration: 300}),
    headShakeAnimation()]
})
export class LoginLegacyPage implements OnInit {

  isSubmitted = false;
  loginData: LoginForm = null;
  loginForm: FormGroup = null;
  loading = null;
  isPageReady = false;
  platform = 'website';
  theme = 'default';

  authType = null;
  id_token = null;

  isOktaEnabled = false;

  profileJson = null;

  public animationState = false;

  constructor(
    private event: EventsService,
    private analytics: AnalyticsService,
    private requesterService: RequesterService,
    private alertController: AlertController,
    private authService: AuthService,
    public userService: UserService,
    private progressService: ProgressService,
    private navCtrl: NavController,
    private translate: TranslateService,
    private linkSystem: NavService,
    private loadingController: LoadingController,
    private fb: FormBuilder,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private oktaAuth: OktaAuthService,
    private platformService: Platform,
    private activatedRoute: ActivatedRoute,
    // private msal: Msal,
  ) {
    if (!!this.authService.isLoggedin()) {
      console.log('LoginPage - Already logged in');
      this.linkSystem.navigateHome();
      // this.navCtrl.navigateRoot(['/home']);
    }
    this.loginData = new LoginForm();
    this.loginData.blockManagerLogin = environment.blockManagerLogin;

    this.isOktaEnabled = environment.oktaEnabled;

    this.platform = this.authService.appMobile ? 'mobile' : 'website';

    this.authType = this.activatedRoute.snapshot.data.authType;
    console.log('LoginPage - AuthType', this.authType);

    if (this.authType === 'okta') {
      // #access_token=eyJhbGciOiJkaXIiLCJlbmMiOiJBMjU2R0NNIiwiaXNzIjoiaHR0cHM6Ly9kZXYtYWxjaGVtaXN0LnVrLmF1dGgwLmNvbS8ifQ..w0ioIFTzG8BAhyq8.gAi7CiYGK81tlY19N7g6Dwduq_u2EPkwJ6S-e29F0s56qN7NYnXw4MgU-MCPZ233Q_x_3OtPDVVLVA6ahC3nzz1uHfrcTYGWluGQQKVGEwreOCBz8v4ZB_pUuZOHRalTIVd1W3Xh-I3eZ2qxmvoNZ3LzM8cdRQnL5_UrbnQuI7QRH_2D7zmELkC3ato67eibgpdfer4HHTU4_qKs_csAw3YZlpfZ23r4AvLEtsdc3YR5spiG-4NCIkshQ_tLQmkXQocqhKBqlW47soKJhz1As3Sq2N7Pm8UP3yRN1I-RRLFamrDkgbP4Hyxq_RIcJDybGcLT_jgXCP6Xt6lkruk1sR9lTt67Y-1Ys3cHZ-Wcsc9BSgVE4xUFpfXI1wZx04MFQQ-cjd4.V7lpFmeULvcMj6JFjfvrFw&scope=openid%20email&expires_in=7200&token_type=Bearer
      const fragment = this.activatedRoute.snapshot.fragment;

      if (!!fragment && fragment.startsWith('access_token=')) {
        this.id_token = fragment.split('&')[0].split('=')[1];
        console.log('LoginPage - id_token', this.id_token);
      }
    }
  }

  ngOnInit() {
    if (environment.platform === 'website') {
      if (this.authType !== 'okta') {
        this.msalBroadcastService.inProgress$
          .pipe(
            filter((status: InteractionStatus) => status === InteractionStatus.None)
          )
          .subscribe(() => {
            const account = this.msalService.instance.getActiveAccount();
            if (account) {
              this.onMicrosoftLogin();
            } else {
              console.log('LoginPage - Microsoft - Not authorized');
            }
          });
      }

      if (this.authType === 'okta') {
        if (this.id_token) {
          this.loginWithOktaTokenHandler(this.id_token);
        } else {
          this.oktaAuth.user$.subscribe(
            (profile) => {
              console.log('LoginPage - ngOnInit - Okta Profile', profile);
              if (profile) {
                this.profileJson = JSON.stringify(profile, null, 2);
                this.onOktaLogin();
              } else {
                console.log('LoginPage - ngOnInit - Okta - Not authorized');
              }
            }
          );
        }
      }
    }
    this.theme = environment.theme;

    this.loginForm = this.fb.group({
      login: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  ionViewDidEnter() {
    this.analytics.trackView('Login');
    setTimeout(() => {
      this.isPageReady = true;
    }, 100);
  }

  async onSubmit() {
    const controls = this.loginForm.controls;

    Object.keys(controls).forEach(key => {
      controls[key].markAsTouched();
    });

    this.isSubmitted = true;

    if (this.loginForm.status !== 'VALID') {
      this.animateInvalidFields();
      return false;
    }

    await this.presentLoadingWithOptions();
    setTimeout(_ => {
      this.loginData.login = this.loginForm.value.login;
      this.loginData.password = this.loginForm.value.password;
      this.requesterService.post('login', this.loginData)
        .then(data => this.loginHandler(data))
        .catch(() => this.loading.dismiss());
    });
  }

  onMicrosoftLogin(method = 'silent') {
    const account = this.msalService.instance.getActiveAccount();

    const accessTokenRequest = {
      scopes: [
        'User.Read',
        // "Team.ReadBasic.All",
        // "Group.Read.All",
        // "Channel.ReadBasic.All",
        // "ChannelMessage.Read.All",
        // "ChannelMessage.Send"
      ],
      account,
    };

    this.msalService.instance.acquireTokenSilent(
      accessTokenRequest
    ).then(async token => {
      const loginSsoData = {
        loginMethod: 'MSAL',
        accessToken: token.accessToken,
        tenantId: token.account.tenantId
      };
      localStorage.setItem('msToken', token.accessToken);
      console.log('LoginPage - onMicrosoftLogin - Login with Microsoft', loginSsoData);
      await this.presentLoadingWithOptions();
      setTimeout(_ => {
        this.requesterService.post('login', loginSsoData)
          .then(data => this.loginHandler(data))
          .catch(() => this.loading.dismiss());
      });
    }).catch((e) => {
      console.log('error', e);
      this.navCtrl.navigateRoot(['/login']);
    });
  }

  onOktaLogin(method = 'silent') {
    this.oktaAuth.getAccessTokenSilently()
      .subscribe(async token => {
        console.log('LoginPage - onOktaLogin - Token', token);
        await this.loginWithOktaTokenHandler(token);
      });
  }

  toLink(url) {
    this.linkSystem.toLink(url, '_self');
  }

  private async loginWithOktaTokenHandler(token) {
    const loginSsoData = {
      loginMethod: 'OKTA',
      accessToken: token,
      tenantId: 'OKTA'
    };
    localStorage.setItem('oktaToken', token);
    console.log('LoginPage - onOktaLogin - Login with OKTA', loginSsoData);
    await this.presentLoadingWithOptions();
    setTimeout(_ => {
      this.requesterService.post('login', loginSsoData)
        .then(data => this.loginHandler(data))
        .catch(() => this.loading.dismiss());
    });
  }

  private loginHandler(data) {
    this.loading.dismiss();
    if (data.error.isError) {
      this.analytics.trackEvent('exception', {
        description: 'Login Error: ' + data.error.errorMessage,
        fatal: false
      });
      if (data.error.errorMessage === '__ALERT_UPGRADE_MESSAGE_LEGACY__') {
        this.alertController.create({
          header: this.translate.instant('__ALERT_UPGRADE_TITLE__'),
          message: this.translate.instant('__ALERT_UPGRADE_MESSAGE__'),
          buttons: [{
            text: this.translate.instant('__ALERT_UPGRADE_BUTTON__'),
            handler: () => {
              if (this.authService.appPlatform === 'ios') {
                this.linkSystem.toLink('https://apps.apple.com/app/learning-journey/id1503395017');
              } else {
                this.linkSystem.toLink('https://play.google.com/store/apps/details?id=com.my721.journey');
              }
            }
          }]
        }).then(a => a.present());
      } else {
        this.alertController.create({
          header: this.translate.instant('__ALERT_ERROR_TITLE__'),
          message: this.translate.instant(data.error.errorMessage),
          buttons: [this.translate.instant('__ALERT_ERROR_BUTTON__')]
        }).then(a => a.present());
      }
      this.navCtrl.navigateRoot(['/login']);
      throw new Error('LOGIN_ERROR');
    } else {
      if (data.result.userType === 'manager') {
        this.authService.setUserType('manager');
      } else if (data.result.userType === 'coach') {
        this.authService.setUserType('coach');
      } else {
        this.authService.setUserType('learner');
      }
      this.authService.setToken(data.result.token);
      // this.myTranslationService.initTranslation();
      this.event.publish('login', this.authService.getUserType());

      this.userService.getUserInfo()
        .then((user) => {
          this.analytics.trackEvent('login', {method: 'auth'});
          if (!user.agree) {
            this.linkSystem.navigate(['account/consent']);
            return;
          }

          const redirectUrl = this.authService.getRedirectUrl();
          if (!!redirectUrl && redirectUrl !== 'null') {
            this.linkSystem.navigateByUrl(redirectUrl);
            this.authService.clearRedirectUrl();
          } else {
            this.linkSystem.navigateHome();
          }
        });
    }
  }

  animateInvalidFields() {
    this.animationState = false;
    setTimeout(() => {
      this.animationState = true;
    }, 1);
  }

  oktaLogin() {
    this.oktaAuth.loginWithRedirect({
      appState: { target: '/login/okta/auth' }
    });
  }

  forgotPassword() {
    this.linkSystem.toLink('https://my721.com/retrieval/');
    // this.linkSystem.toLink('https://alchemist-techsupport.freshdesk.com/support/home');
  }

  async presentLoadingWithOptions() {
    this.loading = await this.loadingController.create({
      duration: 5000,
      translucent: true,
      message: null, // 'Please wait...',
      cssClass: 'loading-no-message'
    });
    await this.loading.present();
  }
}
